import React,{useState,useEffect} from 'react'
import "./nav.css"

function Navbar() {
    const [show,handleshow]=useState(false);


    useEffect(() => {
       window.addEventListener("scroll",()=>
       {
           if(window.scrollY>100){
               handleshow(true);
           }else handleshow(false);


       });
       
        
    }, []);

    return (
        <div className={`nav ${show && "nav_bar"}`}>
            <div className="netflixlogo"><img className="netflixlogo" 
             src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/799px-Netflix_2015_logo.svg.png"
            alt="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/799px-Netflix_2015_logo.svg.png"></img></div>
            <div className="netflixlogo2"> 
            <img className="netflixlogo2"
              src= "https://upload.wikimedia.org/wikipedia/commons/c/c2/Crystal_Clear_app_Login_Manager_2.png"></img>
             </div>

            
        </div>
    )
}

export default Navbar
